import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../../enums/queryKeys'
import { SendAsEmailModalVariant } from '../../enums/sendAsEmailModalVariant'
import { useSendAsEmail } from '../sendAsEmail/useSendAsEmail'

interface UseSendQuoteAsEmailProps {
  onSuccess?: () => void
}

export const useSendQuoteAsEmail = ({ onSuccess }: UseSendQuoteAsEmailProps = {}) => {
  const queryClient = useQueryClient()

  return useSendAsEmail(SendAsEmailModalVariant.Invoice, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.Quote)
      queryClient.invalidateQueries(QueryKeys.QuotesSummary)
      queryClient.invalidateQueries(QueryKeys.Quotes)
      onSuccess?.()
    },
  })
}
